import React, { useRef } from "react";

// utils
import { changeDateFormat, moneyFormatter } from "bodycodi/cmap/app/js/common";

export const RecommendCard = ({ details }: any) => {
  const ref = useRef<any>(null);

  const handleImgLoad = () => {
    ref.current.classList.add("loaded");
  };

  return (
    <div className="cards">
      <div ref={ref} className="blurred-img">
        <img src={details?.detailImgUrl} loading="lazy" onLoad={handleImgLoad} />
      </div>

      <div className="text">
        <div className="title">
          <span>{details?.prodName}</span>
        </div>

        <span className="price">{moneyFormatter(details?.price)}</span>
      </div>
    </div>
  );
};

export const CenterPlusCard = ({ details }: any) => {
  const ref = useRef<any>(null);

  const handleImgLoad = () => {
    ref.current.classList.add("loaded");
  };

  const USE_PERIOD_TYPE_OBJECT: any = {
    M: "개월",
    D: "일",
  };

  const getUsageDetails = () => {
    return details?.pricingDetails?.map((item: any, index: any) => {
      const { useNumber, usePeriod, usePeriodType, dayLimit, weekLimit, weekLimitDayFlag } = item;

      const USE_NUMBER = useNumber === -1 ? "무제한" : useNumber + "회";
      const USE_PERIOD = usePeriod + USE_PERIOD_TYPE_OBJECT[usePeriodType];
      const DAY_LIMIT = dayLimit === -1 ? "무제한" : dayLimit + "회";
      const WEEK_LIMIT =
        weekLimit === -1 ? "무제한" : weekLimit + weekLimitDayFlag === "D" ? "일" : "회";

      if (details?.serviceCategory === "NORMAL") {
        return (
          <span className="gray" key={index}>
            {`${USE_NUMBER} / ${USE_PERIOD} / 일일 : ${DAY_LIMIT} · 주간 : ${WEEK_LIMIT}`}
          </span>
        );
      }

      return (
        <span className="gray" key={index}>
          {`${item?.serviceName} ${USE_NUMBER} ${USE_PERIOD} (일일 : ${DAY_LIMIT} · 주간 : ${WEEK_LIMIT})`}
        </span>
      );
    });
  };

  return (
    <div className="cards">
      <div ref={ref} className="blurred-img">
        <img src={details?.coverImg} loading="lazy" onLoad={handleImgLoad} />
      </div>

      <div className="text">
        <div className="title">
          <span>{details?.prodName}</span>
        </div>
        <span className="gray">{`${changeDateFormat(details?.saleStartDt, true)} ~ ${
          details?.saleEndDt === "9999-12-31"
            ? "미지정"
            : changeDateFormat(details?.saleEndDt, true)
        }`}</span>
        {getUsageDetails()}
        <span className="price">{moneyFormatter(details?.price)}</span>
      </div>
    </div>
  );
};

export const HomeTrainingCard = ({ details }: any) => {
  const ref = useRef<any>(null);

  const handleImgLoad = () => {
    ref.current.classList.add("loaded");
  };

  return (
    <div className="cards">
      <div ref={ref} className="blurred-img">
        <img src={details?.coverImg} loading="lazy" onLoad={handleImgLoad} />
      </div>

      <div className="text">
        <div className="title">
          {details?.packageYn === "Y" && <div className="badge">패키지</div>}
          <span>{details?.prodName}</span>
          {details?.totalNumVideos && (
            <span className="tag blue">{`${details?.totalNumVideos}강`}</span>
          )}
        </div>
        <span className="price">{moneyFormatter(details?.price)}</span>
      </div>
    </div>
  );
};
